import { cva, type VariantProps } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center gap-1.5 font-display font-medium tracking-wider uppercase',
  {
    variants: {
      variant: {
        default: 'bg-surface text-fg-muted border border-border',
        primary: 'bg-primary/15 text-primary border border-primary/30',
        secondary: 'bg-secondary/15 text-secondary border border-secondary/30',
        success: 'bg-success/15 text-success border border-success/30',
        outline: 'border border-border-strong text-fg-muted',
      },
      size: {
        sm: 'text-[10px] px-2 py-0.5 rounded-md',
        md: 'text-xs px-2.5 py-1 rounded-md',
      },
    },
    defaultVariants: { variant: 'default', size: 'md' },
  },
)

export type BadgeVariantProps = VariantProps<typeof badgeVariants>
